import React from "react";
import { useDispatch } from 'react-redux';
import { setRegion } from '../features/counter/RegionSlice';
import { Box, Button } from "@mui/material";

const Region = [
  { id: 1, Region: "All Region" },
  { id: 2, Region: "France" },
  { id: 3, Region: "Germany" },
  { id: 4, Region: "Italy" },
  { id: 5, Region: "Spain" },
  { id: 6, Region: "Switzerland" },
  { id: 7, Region: "UK" }
];

const RegionButtons = () => {
  const dispatch = useDispatch();

  const handleRegionChange = (newRegion) => {
    dispatch(setRegion(newRegion));
  };

  return (
    <Box display="flex" justifyContent="center" flexWrap="wrap" gap={2} border={1} borderColor="grey.500" p={2} mt={2}>
      {Region.map((item) => (
        <Button
          variant="outlined"
          key={item.id}
          onClick={() => handleRegionChange(item.Region)}
          sx={{ '&.Mui-active': { backgroundColor: 'blue' } }}
        >
          {item.Region}
        </Button>
      ))}
    </Box>
  );
};

export default RegionButtons;
